export const sentenceStructure = [
  {
    id: 'hauptsatz',
    category: 'satzbau',
    level: 'A1',
    title: 'Hauptsatz (Fjalia Kryesore)',
    detailedContent: `
      <section>
        <p><b>Fjalia Kryesore (Hauptsatz)</b> është një fjali thelbësore e cila mund të qëndrojë e vetme dhe të ketë kuptim të plotë pa patur nevojë për fjali të tjera ngjitur.</p>

        <h3>Rregulli i Artë Gjerman i "Pozicionit 2"</h3>
        <p>Në një fjali dëftore treguese, pavarësisht çfarë fjale vendosni të parën (Subjektin, Kohën, Vendin), <b>FOLJA E ZGJEDHUAR DUHET TË JETË GJITHMONË NË POZICIONIN E DYTË!</b></p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Skema Klasike:</strong> [Subjekti (1)] + <b>[Folja Krysore (2)]</b> + [Koha (3)] + [Objekti (4)] + [Vendi (5)]
        </div>

        <ul>
          <li><i>Ich <b>lerne</b> heute Deutsch zu Hause.</i> (Ich = 1. Lerne = 2. Heute = 3. Deutsch = 4...).</li>
          <li><i>Mein bester Freund <b>kommt</b> aus dem Kosovo.</i> (Edhe pse "Mein bester Freund" ka 3 fjalë, ai llogaritet si 1 Gja! = Pozicioni 1 i subjektit. Folja kommt është prap në pozitën e 2-të logjike).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: [
      { question: 'Zgjidhni formën e saktë (Pozicionin 2):', options: ['Wir oft gehen ins Kino.', 'Wir gehen oft ins Kino.'], correct: 1, explanation: 'Folja "gehen" thelbesisht duhet të zërë vendin e dytë pas subjektit (Wir).' }
    ]
  },
  {
    id: 'inversion',
    category: 'satzbau',
    level: 'A2',
    title: 'Inversion (Anasjellja e Subjektit)',
    detailedContent: `
      <section>
        <p>Nganjëherë ne theksojmë KOHËN ose VENDIN (p.sh. "HË PËR HË... / SOT.../ ATJE...") duke i vendosur të parat në gjermanisht! Çfarë ndodh në këtë ras me Rregullin e Pozicionit 2? Rregulli thelb mbetet i SHENJTË!</p>
        
        <h3>Mekanizmi i Inversionit:</h3>
        <p>Folja e zgjedhuar ZË PA DISKUTIM VENDIN E DYTË. Pasi folja e zuri vendin 2, Mbetushi Subjekt thelbthjesht <b>Kalojmbrapa foljes (në pozicionin 3)</b>.</p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> [Koha / Vendi (1)] + <b>[Folja Krysore (2)]</b> + [Subjekti (3)] + [Të tjerat (4)]
        </div>

        <ul>
          <li>E rregullt: <i>Ich (1) <b>gehe</b> (2) heute (3) ins Kino.</i></li>
          <li>E përmbysur (Inversion) theksuese nga koha: <i>Heute (1) <b>gehe</b> (2) ich (3) ins Kino.</i> (Mos the "Heute ich gehe". Kjo është gabim thellë).</li>
          <li>E përmbysur theksuese nga Vendi: <i>Dort (1) <b>wohnt</b> (2) mein Bruder (3).</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: [
      { question: 'Përkthe saktsisht me përmbysje thelb: "Të hënën, unë luaj basketboll."', options: ['Am Montag ich spiele Basketball.', 'Am Montag spiele ich Basketball.'], correct: 1, explanation: 'Am Montag zë thelbin #1. Spela duhet t jët detyrimshit e #2-ta. Subjekti (ich) del as saj n pozit 3.' }
    ]
  },
  {
    id: 'satzklammer',
    category: 'satzbau',
    level: 'B2',
    title: 'Satzklammer (Kllapa e Fjalisë / Darjet e thelbit)',
    detailedContent: `
      <section>
        <p>Magjia strukturore thelbsore e Gjermanishtet. Quhen kllapa apo darje sepse kur ka <b>2 folje në fjali</b> (një Ndihmëse modelale/perfekt dhe një Kryesore), ato TË DYA kapin skajet M të largeta të fjalisë për ta mbyllur si thelb Kllap</p>
        
        <h3>Si formohen Kllapat (Die Klammer)?</h3>
        <ol>
          <li><b>Folja Ndihmëse Zgjedhohet =</b> Qundron tek e zakonshmja Pozita e 2-të.</li>
          <li><b>Folja e dytë Kryesore e ngriet / paprekur (Infinitiv a Partizip) =</b> Flaket ABSOLUTISHTE FUND FJALisë Pika.</li>
        </ol>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Skema Klasike Modeale/Perfekt:</strong> Ich <b>habe</b> [shumë fjalë.. t.. tjera] <b>gespielt</b>. (Una kam... luajtur).
        </div>

        <ul>
          <li>Me foljet Modale: <i>Ich <b>muss</b> heute mit meinem Chef <b>sprechen</b>.</i></li>
          <li>Në të Shkuarën Perfect: <i>Wir <b>haben</b> gestern im Park Fußball <b>gespielt</b>.</i></li>
          <li>Me Foljet e Ndashme (Trennbar): <i>Ich <b>mache</b> die Tür Thelb <b>zu</b>.</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'tekamolo',
    category: 'satzbau',
    level: 'B1',
    title: 'Rregulli TE-KA-MO-LO (Radha e thelbeve)',
    detailedContent: `
      <section>
        <p>Nëse skeni çfar të thekshoni thelbësisht fare! Dhe doni që gjithëçka të rrije e thatë, në cilionin rredhn renditen informacionet kohore vs vendsore brenda fjalisës?</p>
        <p>Gjermanishtja ka një rregulll mnemonik të thatë T.K.M.L.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <ol>
            <li><b>TE</b> (Temporal - Koha) - <i>Wann?</i></li>
            <li><b>KA</b> (Kausal - Shkaku) - <i>Warum?</i></li>
            <li><b>MO</b> (Modal - Mënyra) - <i>Wie?</i></li>
            <li><b>LO</b> (Lokal - Vendi) - <i>Wo / Wohin?</i></li>
          </ol>
        </div>

        <ul>
          <li><i>Ich fahre <b>heute</b> (TE) <b>wegen des Wetters</b> (KA) <b>schnell</b> (MO) <b>nach Hause</b> (LO).</i></li>
          <li><i>Er lernt <b>jeden Tag</b> (TE) <b>mit dem Buch</b> (MO) <b>in der Bibliothek</b> (LO).</i> (Vini re vargu: Kohë-Mënyrë-Vendit).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
